import { AttributesList, createAttributesItem as createItem } from 'src/utils/createAttributesItem.ts';
import { ActuatorData, ValveData } from 'src/modules/checkout/CheckoutPageMapping.ts';
import { DashValue } from 'src/modules/valves/ValveCard/DashValue.ts';
import { filterEmpty } from 'src/utils/filterEmpty.ts';
import { AttributesAliases } from 'src/generated/dict.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';

export function prepareComboAttributes(
    valve: ValveData,
    actuator: ActuatorData,
): [AttributesList, AttributesList] {
    let attrs: [AttributesList, AttributesList] = [[], []];
    const product: ActuatorData = actuator || valve;
    if ('kvs' in valve) {
        const clipPosKvs = valve.getClipPositionKvs
            ? { raw: [valve.getClipPositionKvs], localized: [valve.getClipPositionKvs] } : null;
        attrs = [
            [
                [AttributesAliases.dn, valve.dn],
                ...(valve.getClipPosition ? createItem(
                    MESSAGES.clipPosition,
                    { raw: [valve.getClipPosition], localized: [valve.getClipPosition] },
                ) : []),
                ...(valve.getClipPositionPI ? createItem(
                    MESSAGES.clipPosition,
                    { raw: [valve.getClipPositionPI], localized: [valve.getClipPositionPI] },
                ) : []),
                ...createItem(AttributesAliases.kvs, clipPosKvs || valve.kvs || valve.kvssequence1),
                ...createItem(AttributesAliases.kvmax, valve.kvmax),
                ...createItem(AttributesAliases.vnomls, valve.vnomm3h),
                ...createItem(AttributesAliases.kvssequence2, valve.kvssequence2),
                ...(valve.calcEffectiveDpv ? createItem(
                    MESSAGES.EffectiveDpv,
                    { raw: [valve.calcEffectiveDpv], localized: [valve.calcEffectiveDpv] },
                ) : []),
                ...(valve.calcMinReqDpv ? createItem(
                    MESSAGES.MinReqDpv,
                    { raw: [valve.calcMinReqDpv], localized: [valve.calcMinReqDpv] },
                ) : []),
                ...(valve.calcEffectivePV ? createItem(
                    MESSAGES.EffectivePV,
                    { raw: [valve.calcEffectivePV], localized: [valve.calcEffectivePV] },
                ) : []),
                [AttributesAliases.FluidTemperatureRange, valve.FluidTemperatureRange],
                [AttributesAliases.PN, valve.PN],
                ...(valve.calcFlowVelocity ? createItem(
                    MESSAGES.FlowVelocity,
                    { raw: [valve.calcFlowVelocity], localized: [valve.calcFlowVelocity] },
                ) : []),
            ], [
                [AttributesAliases.nominalVoltage, product.nominalVoltage || DashValue],
                [AttributesAliases.controlType, product.controlType || DashValue],
                [AttributesAliases.runningTime, product.runningTime || DashValue],
                [AttributesAliases.failSafeFunction, product.failSafeFunction || DashValue],
            ]];
    }
    if ('cv' in valve) {
        const clipPosKvs = valve.getClipPositionKvs
            ? { raw: [valve.getClipPositionKvs], localized: [valve.getClipPositionKvs] } : null;
        attrs = [
            [
                [AttributesAliases.bodySize, valve.bodySize],
                ...(valve.getClipPosition ? createItem(
                    MESSAGES.clipPosition,
                    { raw: [valve.getClipPosition], localized: [valve.getClipPosition] },
                ) : []),
                ...(valve.getClipPositionPI ? createItem(
                    MESSAGES.clipPosition,
                    { raw: [valve.getClipPositionPI], localized: [valve.getClipPositionPI] },
                ) : []),
                ...createItem(AttributesAliases.cv, clipPosKvs || valve.cv || valve.cvsequence1),
                ...createItem(AttributesAliases.vnomgpm, valve.vnomgpm),
                ...createItem(AttributesAliases.cvsequence1, valve.cvsequence1),
                ...createItem(AttributesAliases.cvsequence2, valve.cvsequence2),
                ...(valve.calcEffectiveDpv ? createItem(
                    MESSAGES.EffectiveDpv,
                    { raw: [valve.calcEffectiveDpv], localized: [valve.calcEffectiveDpv] },
                ) : []),
                ...(valve.calcMinReqDpv ? createItem(
                    MESSAGES.MinReqDpv,
                    { raw: [valve.calcMinReqDpv], localized: [valve.calcMinReqDpv] },
                ) : []),
                ...(valve.calcEffectivePV ? createItem(
                    MESSAGES.EffectivePV,
                    { raw: [valve.calcEffectivePV], localized: [valve.calcEffectivePV] },
                ) : []),
                [AttributesAliases.FluidTemperatureRange, valve.FluidTemperatureRange],
                [AttributesAliases.CloseOffPressure, valve.closeOffPressure],
                ...(valve.calcFlowVelocity ? createItem(
                    MESSAGES.FlowVelocity,
                    { raw: [valve.calcFlowVelocity], localized: [valve.calcFlowVelocity] },
                ) : []),
            ], [
                [AttributesAliases.nominalVoltage, product.nominalVoltage || DashValue],
                [AttributesAliases.controlType, product.controlType || DashValue],
                [AttributesAliases.runningTime, product.runningTime || DashValue],
                [AttributesAliases.failSafeFunction, product.failSafeFunction || DashValue],
            ],
        ];
    }
    return [attrs[0].filter(filterEmpty), attrs[1].filter(filterEmpty)];
}
